import axios from 'axios';
import { API_BASE_URL } from '../api';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const getFabricTemplates = async () => {
  const res = await axios.get(`${API_BASE_URL}/fabric-templates`, {
    headers: authHeaders(),
    timeout: 30000,
  });
  return res.data?.data?.fabricTemplates || [];
};

export const createFabricTemplate = async (templateData) => {
  const res = await axios.post(`${API_BASE_URL}/fabric-templates`, templateData, {
    headers: authHeaders(),
    timeout: 30000,
  });
  return res.data?.data?.fabricTemplate;
};

export const updateFabricTemplate = async (id, templateData) => {
  const res = await axios.put(`${API_BASE_URL}/fabric-templates/${id}`, templateData, {
    headers: authHeaders(),
    timeout: 30000,
  });
  return res.data?.data?.fabricTemplate;
};

export const deleteFabricTemplate = async (id) => {
  await axios.delete(`${API_BASE_URL}/fabric-templates/${id}`, {
    headers: authHeaders(),
    timeout: 30000,
  });
};
